import { render, staticRenderFns } from "./IntermediaryForm.vue?vue&type=template&id=70a32583&scoped=true&"
import script from "./IntermediaryForm.vue?vue&type=script&lang=js&"
export * from "./IntermediaryForm.vue?vue&type=script&lang=js&"
import style0 from "./IntermediaryForm.vue?vue&type=style&index=0&id=70a32583&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a32583",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
